import { render, staticRenderFns } from "./CountdownClient.vue?vue&type=template&id=67970eb8"
import script from "./CountdownClient.vue?vue&type=script&lang=js"
export * from "./CountdownClient.vue?vue&type=script&lang=js"
import style0 from "./CountdownClient.vue?vue&type=style&index=0&id=67970eb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports